import React from 'react';

export const EndPoint = () => (
  <div className="end-point-marker">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 56" width="30" height="28">
      <g id="-e-123">
        <path id="Rectangle 1" className="shp0" d="M4 4L56 4L56 33L4 52L4 4Z"/>
        <path id="Rectangle 4 copy 4" className="shp1" d="M23 15L26 15L26 31L23 31L23 15ZM29 15L32 15L32 18L29 18L29 15ZM35 15L38 15L38 18L35 18L35 15ZM26 18L29 18L29 21L26 21L26 18ZM32 18L35 18L35 21L32 21L32 18ZM29 21L32 21L32 24L29 24L29 21ZM35 21L38 21L38 24L35 24L35 21Z"/>
      </g>
    </svg>
  </div>
);
